<template>
  <v-navigation-drawer
    right
    stateless
    floating
    :fixed="true"
    :clipped="true"
    :value="navigationDrawerOpen"
    app
  >
    <Toc />
    <Calendar />
    <Tasks />
    <MessageStats />
    <News />
  </v-navigation-drawer>
</template>

<script>
import Calendar from "./rightbar/Calendar";
import MessageStats from "./rightbar/MessageStats";
import News from "./rightbar/News";
import Tasks from "./rightbar/Tasks";
import Toc from "./rightbar/Toc";
import { mapGetters } from "vuex";
export default {
  name: "Rightbar",
  components: {
    Calendar,
    MessageStats,
    News,
    Tasks,
    Toc
  },
  computed: {
    ...mapGetters(["navigationDrawerOpen"])
  }
};
</script>
